import * as React from 'react';
import './PVABadge.css';

interface PVAContainerProps {
    icon?: any;
    id: string;
    title: any;
    content: any;
    open?: boolean;
    offset?: boolean;
    clickableHeader?: boolean;
}

export class PVAContainer extends React.Component<PVAContainerProps, { open: boolean, offset?: boolean }> {
    constructor(props: PVAContainerProps) {
        super(props);

        var isOpen = false;
        if (props.open == null) {// or undefined
            isOpen = true;
        } else {
            isOpen = props.open;
        }
        
        this.state = {
            open: isOpen,
            offset: props.offset
        };
    }

    private getOffset() {
        if (this.state.offset) {
            return <div className="invisible-offset"><br/></div>;
        }

        return;
    }

    private toggle() {
        if (this.props.clickableHeader) {
            this.setState({ open: !this.state.open });
        }
    }

    render() {
        return (
            <div id={this.props.id} className="pva-group">
                {this.getOffset()}
                <div className="pva-group-title simple">

                    <div className="icon-state">
                        {this.props.icon}
                    </div>
                    <div className="remainder">
                        <div className="row">
                            <div className="col-xs-10 title truncate" onClick={() => this.toggle()}>
                                {this.props.title}
                            </div>
                            <div className="col-xs-2 toggle text-right" onClick={(e) => { this.setState({ open: !this.state.open }); }}>
                                {this.state.open && <span className="glyphicon glyphicon-triangle-bottom" />}
                                {!this.state.open && <span className="glyphicon glyphicon-triangle-top" />}
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.open &&
                    <div className="pva-group-content">
                        {this.props.content}
                    </div>
                }
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAContainer.tsx